export default __webpack_public_path__ + "static/media/loginPageBush.86894cd9.svg";